var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeatSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33V3C33 1.34315 31.6569 0 30 0L5 0C3.34315 0 2 1.34315 2 3L2 33C2 34.6569 3.34315 36 5 36H30C31.6569 36 33 34.6569 33 33Z",
    fill: "#663366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 33V3C32.5 1.61929 31.3807 0.5 30 0.5L5 0.5C3.61929 0.5 2.5 1.61929 2.5 3L2.5 33C2.5 34.3807 3.61929 35.5 5 35.5H30C31.3807 35.5 32.5 34.3807 32.5 33Z",
    stroke: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 31V13C35 11.3431 33.6569 10 32 10C30.3431 10 29 11.3431 29 13V31C29 32.6569 30.3431 34 32 34C33.6569 34 35 32.6569 35 31Z",
    fill: "#663366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 31V13C34.5 11.6193 33.3807 10.5 32 10.5C30.6193 10.5 29.5 11.6193 29.5 13V31C29.5 32.3807 30.6193 33.5 32 33.5C33.3807 33.5 34.5 32.3807 34.5 31Z",
    stroke: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 31L6 13C6 11.3431 4.65685 10 3 10C1.34315 10 0 11.3431 0 13L0 31C0 32.6569 1.34315 34 3 34C4.65685 34 6 32.6569 6 31Z",
    fill: "#663366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 31L5.5 13C5.5 11.6193 4.38071 10.5 3 10.5C1.61929 10.5 0.5 11.6193 0.5 13L0.5 31C0.5 32.3807 1.61929 33.5 3 33.5C4.38071 33.5 5.5 32.3807 5.5 31Z",
    stroke: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 37H29.5C31.433 37 33 35.433 33 33.5C33 31.567 31.433 30 29.5 30L5.5 30C3.567 30 2 31.567 2 33.5C2 35.433 3.567 37 5.5 37Z",
    fill: "#663366"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 36.5H29.5C31.1569 36.5 32.5 35.1569 32.5 33.5C32.5 31.8431 31.1569 30.5 29.5 30.5L5.5 30.5C3.84315 30.5 2.5 31.8431 2.5 33.5C2.5 35.1569 3.84315 36.5 5.5 36.5Z",
    stroke: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatSelected);
export default __webpack_public_path__ + "static/media/seat-selected.46b730c5264aa189507df4f31250a1fe.svg";
export { ForwardRef as ReactComponent };